import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Canonical subscription link handler
 * (/customers/:customerId/subscriptions/:subscriptionId).
 *
 * Normalizes the canonical path into the query form the customer page already
 * understands (?tab=services&subscriptionId=…), so a subscription deep link —
 * from email or an intercepted universal link — lands on the customer page with
 * that subscription selected. Keyed off useParams so a re-fire during the lazy
 * CustomerDetails transition only reproduces the same URL.
 */
export function SubscriptionRedirect() {
  const { customerId, subscriptionId } = useParams<{
    customerId: string;
    subscriptionId: string;
  }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!customerId || !subscriptionId) return;
    navigate(`/customers/${customerId}?tab=services&subscriptionId=${subscriptionId}`, {
      replace: true,
    });
  }, [customerId, subscriptionId, navigate]);

  return null;
}
